import React from "react";
import { HolidaySchedule } from "../../../models/HolidaySchedule";
import { Heading, Subheading } from "../../../design/heading";
import DeleteHolidayScheduleButton from "../../../components/DeleteHolidaySchedule";
import { TrashIcon, PencilIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import { Button } from "../../../design/button";
import { Link } from "../../../design/link";
import HolidayScheduleStatusBadge from "../../../components/HolidayScheduleStatusBadge";

interface HolidayRuleLineItemProps {
  holidaySchedule: HolidaySchedule;
}

const DraftHolidayScheduleListItem: React.FC<HolidayRuleLineItemProps> = ({
  holidaySchedule,
}) => {
  return (
    <div className="flex items-start justify-between p-4 transition border rounded-lg shadow-sm hover:shadow">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Link href={`/holiday-schedule/${holidaySchedule._id}`}>
            <Heading className="text-lg">{holidaySchedule.name}</Heading>
          </Link>
          <HolidayScheduleStatusBadge status={holidaySchedule.status} />
        </div>
        <Subheading className="text-sm text-muted-foreground">
          Last updated:{" "}
          {moment(holidaySchedule.updatedAt).format("MMMM D, YYYY")} &middot;{" "}
        </Subheading>
        <Subheading className="text-sm text-muted-foreground">
          {holidaySchedule.holidayRules.length} rule
          {holidaySchedule.holidayRules.length !== 1 ? "s" : ""}
        </Subheading>
      </div>

      <div className="flex items-center gap-2">
        <Button href={`/holiday-schedule/${holidaySchedule._id}`}>
          <PencilIcon className="w-5 h-5" />
        </Button>
        <DeleteHolidayScheduleButton holidayScheduleId={holidaySchedule._id}>
          <TrashIcon className="w-5 h-5" />
        </DeleteHolidayScheduleButton>
      </div>
    </div>
  );
};

export default DraftHolidayScheduleListItem;
